import { useLazyQuery, useMutation, useQuery } from "@apollo/client/react"; import React, { useEffect, useState } from 'react';
import GrillaVacia from '../../../assets/images/grilla-vacia-resumen-ingreso.svg';
import { CustomButton } from '../../../components/customButton/CustomButton.jsx';
import { CustomDialog } from '../../../components/customDialog/CustomDialog.jsx';
import { Autocomplete, Box, CircularProgress, InputAdornment, TextField } from '@mui/material';
import { useDebounce } from '../../../hooks/useDebounce.js';

import { GET_INSUMOS_VALIDATE_RI, adaptInsumosArray } from '../../../data/graphQL/queries/Insumos/queries.js';
import SearchIcon from '@mui/icons-material/Search';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile.jsx';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers.js';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico.jsx';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import toast, { Toaster } from 'react-hot-toast';
import { GET_INDICATIONS_BY_EVALUACION, adaptIndicacionesArray } from '../../../data/graphQL/queries/ResumenIngresoValidation/getIndicacionesByEvaluacion.js';
import { CREATE_INDICACION } from '../../../data/graphQL/mutations/ResumenIngresoValidation/CreateIndicacion.js';
import { REMOVE_INDICACION } from '../../../data/graphQL/mutations/ResumenIngresoValidation/DeleteIndicacion.js';
import { CREATE_BAP } from '../../../data/graphQL/mutations/ResumenIngresoValidation/CreateVolumenIndicacionBAP.js';

export const IndicacionInput = ({ idEvaluacion, idTipoModulo, setChildrenAction, readOnly, setCountIndicaciones }) => {
  const ID_MODULO_SIP = 10;

  const commonColumns = [
    {
      headerName: 'Producto',
      field: 'nombreInsumo',
      flex: 0.57
    },
    {
      headerName: 'Cant. Diaria',
      field: 'cantidadDiaria',
      flex: 0.25
    },
    {
      headerName: 'Unidad',
      field: 'unidad',
      flex: 0.2
    }];


  // Agregar la columna 'action' si readOnly es false
  const columns = !readOnly ?
    generateColumnsDefaultConfiguration([
      {
        field: 'action',
        headerName: '',
        flex: 0.03,
        renderCell: (cellProps) => {
          const { row } = cellProps;
          return (
            <DeleteOutlineIcon className='edit-icon' onClick={() => deleteIndicacion(row)} />);

        }
      },
      ...commonColumns]
    ) :
    generateColumnsDefaultConfiguration(commonColumns);

  const [indicaciones, setIndicaciones] = useState([]);

  const [openformModal, setOpenformModal] = useState(false);
  const [productoSelected, setProductoSelected] = useState({});
  const [cantidadDiaria, setCantidadDiaria] = useState();
  const [bap, setBap] = useState({});

  const handleChangeBAP = (name, value) => {
    setBap((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const [
    insumos,
    filterStatus,
    insumosLoading,
    setFilterStatus] =
    useGetInsumos(idEvaluacion);

  const { refetch: refetchIndicaciones, data: indicacionesData } = useQuery(GET_INDICATIONS_BY_EVALUACION, {
    fetchPolicy: 'no-cache',
    variables: { idEvaluacion },
  });

  useEffect(() => {
    if (!indicacionesData) return;

    setIndicaciones(adaptIndicacionesArray(indicacionesData));
  }, [indicacionesData]);

  const [createEvaluacionBAP] = useMutation(CREATE_BAP, {
    fetchPolicy: 'no-cache'
  });

  const [createIndicacion] = useMutation(CREATE_INDICACION, {
    fetchPolicy: 'no-cache'
  });
  const [removeIndicacion] = useMutation(REMOVE_INDICACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    setCountIndicaciones(indicaciones.length);
    if (!indicaciones.length || !!readOnly) return setChildrenAction(null);

    setChildrenAction(() =>
      <CustomButton
        onClick={handleOpenFormModal}
        size='small'
        variant='outlined'>

        Agregar
      </CustomButton>
    );

  }, [indicaciones]);

  const deleteIndicacion = async (indicacion) => {
    try {
      await removeIndicacion({
        variables: {
          idIndicacionEvaluacion: indicacion?.idEvaluacionIndicacion
        }
      });
      const { data: indicacionesData } = await refetchIndicaciones();
      setIndicaciones(adaptIndicacionesArray(indicacionesData));
    } catch (err) {
      console.log(err);
    }
  };

  const handleOpenFormModal = () => setOpenformModal(true);

  const handleCloseFormModal = () => {
    setOpenformModal(false);
    setProductoSelected({});
    setBap({});
    setCantidadDiaria();
  };

  const handleChange = (value) => {
    setProductoSelected(value);
  };

  const onSubmit = async () => {
    try {
      await createIndicacion({
        variables: {
          input: {
            idEvaluacion: idEvaluacion,
            idInsumo: productoSelected.id,
            idTipoModulo: idTipoModulo,
            cantidadDiaria: parseFloat(cantidadDiaria)
          }
        }
      });
      if (bap?.requiereBAP) {
        await createEvaluacionBAP({
          variables: {
            idEvaluacion: idEvaluacion,
            input: {
              idInsumo: null,
              idTipoModulo: idTipoModulo,
              idComboRiSellado: null,
              idComboRiInfusion: null,
              volumenMagistral: parseFloat(bap.volumenMagistral),
              cantidadDiaria: null,
              diasMagistral: null,
              diasEstandar: null
            }
          }
        });
      }
      const { data: indicacionesData } = await refetchIndicaciones();
      setIndicaciones(adaptIndicacionesArray(indicacionesData));
      toast.success('Indicación cargada con éxito');
      handleCloseFormModal();
    } catch (err) {
      toast.error('Ocurrió un error al cargar la indicación');
    }
  };

  return (
    <>
      {!!readOnly &&
        <DataGridGenerico
          columns={columns}
          rows={indicaciones}
          toolbar={false}
          hideFooter />
      }

      {!readOnly && !indicaciones?.length && <div className='resumen-ingreso-grilla-vacia'>
        <div className='svg-clientes-grilla-vacia'>
          <img src={GrillaVacia} width='100%'></img>
        </div>
        <label>No se ha agregado ninguna indicación</label>
        <CustomButton
          onClick={handleOpenFormModal}
          size='small'
          sx={{ margin: '10px' }}>

          Agregar
        </CustomButton>
      </div>}
      {!readOnly && !!indicaciones.length &&
        <DataGridGenerico
          columns={columns}
          rows={indicaciones}
          toolbar={false}
          hideFooter />

      }
      {!readOnly &&
        <CustomDialog
          maxWidth='md'
          fullWidth
          onCancel={handleCloseFormModal}
          open={openformModal}
          cancelText='Cerrar'
          onAccept={onSubmit}
          acceptDisabled={!productoSelected || !cantidadDiaria}
          acceptText='Agregar'
          title='Indicaciones'>

          <Autocomplete
            options={insumos}
            disableClearable
            noOptionsText={filterStatus ? 'No hay coincidencias' : 'Escriba para buscar'}
            onChange={(_, newValue) => handleChange(newValue)}
            onInputChange={(e) => setFilterStatus(e.target.value)}
            renderOption={(props, option) => {
              return (
                <Box {...props} key={option.id}>
                  {option?.label}
                </Box>);

            }}
            renderInput={(params) =>
              <TextField
                {...params}
                sx={{ '.MuiOutlinedInput-root': { paddingRight: '15px !important' } }}
                label='Producto'
                margin='none'
                size='small'
                InputProps={{
                  ...params.InputProps,
                  endAdornment:
                    <InputAdornment position='end'>
                      {insumosLoading ?
                        <CircularProgress color='inherit' size={20} /> :
                        <SearchIcon className='search-icon' />}
                    </InputAdornment>

                }} />
            } />

          <RenderInputByTypeMobile
            grided
            handleChange={(_, value) => setCantidadDiaria(value)}
            input={{
              name: 'cantidadDiaria',
              displayName: 'Cant. diaria',
              type: 'float',
              required: true
            }}
            value={cantidadDiaria} />

          <RenderInputByTypeMobile
            grided
            input={{
              name: 'unidad',
              displayName: 'Unidad',
              type: 'string',
              required: true,
              disabled: true
            }}
            value={productoSelected?.unidad} />

          {
            idTipoModulo == ID_MODULO_SIP && <>
              <RenderInputByTypeMobile
                grided
                handleChange={(name, value) => handleChangeBAP(name, value)}
                input={{
                  name: 'requiereBAP',
                  displayName: 'BAP magistral',
                  type: 'boolean',
                  required: true,
                  disabled: false
                }}
                value={bap?.requiereBAP} />

              <RenderInputByTypeMobile
                grided
                handleChange={(name, value) => handleChangeBAP(name, value)}
                input={{
                  name: 'volumenMagistral',
                  displayName: 'Volumen',
                  type: 'float',
                  required: bap?.requiereBAP,
                  disabled: !bap?.requiereBAP
                }}
                value={bap?.volumenMagistral} />

            </>
          }
        </CustomDialog>}
    </>);

};

const useGetInsumos = (idEvaluacion) => {
  const [insumos, setInsumos] = useState([]);

  const [filterStatus, setFilterStatus] = useState('');
  const debouncedFilterValue = useDebounce(filterStatus, 1000);

  const [getInsumos, { loading: insumosLoading, data: insumosResults }] = useLazyQuery(GET_INSUMOS_VALIDATE_RI, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!insumosResults) return;

    setInsumos(insumosResults);
  }, [insumosResults]);

  useEffect(() => {
    if (!insumosLoading && !!debouncedFilterValue?.trim()) {
      getInsumos({
        variables: {
          idEvaluacion,
          where: { descripcion: { contains: debouncedFilterValue } }
        }
      });
    }
  }, [debouncedFilterValue, idEvaluacion]);

  return [
    adaptInsumosArray(insumos) || [],
    filterStatus,
    insumosLoading,
    setFilterStatus];


};